module.exports = __webpack_public_path__ + "a9dd093446f16ed3f4418b3379d6041e.MP3";